import {defineStore} from "pinia";
import {ref} from "vue";
import {useFetch} from "@/composables/useFetch.js";
import {uri} from "@/constants/config.js";

export const useWalletStore = defineStore('wallet', () => {
    const wallet = ref(null)
    const showWalletDialog = ref(false)
    const showNotification = ref(false)
    const amount = ref(0)
    function fetchWallet() {
        return useFetch(uri.api.wallet.view, {method: "GET"}).then(({data, error}) => {
            wallet.value = error ? null : data;
            if (wallet.value) amount.value = wallet.value.amount
        }).catch(error => {
            wallet.value = null;
        }).finally(() => wallet)
    }

    function openWallet() {
        showWalletDialog.value = true
    }
    function closeWallet() {
        showWalletDialog.value = false
    }

    function openNotification() {
        showNotification.value = true
    }

    function closeNotification() {
        showNotification.value = false
    }



    return {
        amount,
        wallet,
        fetchWallet,
        showWalletDialog,
        openWallet,
        closeWallet,
        showNotification,
        openNotification,
        closeNotification,
    }
})